// Reglas del stock crítico que Home VL toma del lente de inventario — lógica pura, sin React.
import type {
    InventoryLensSkuItem,
    InventoryLensUnavailableReason,
} from '@/api/services/retail-catalog/backoffice';

const UNAVAILABLE_TEXT: Record<InventoryLensUnavailableReason, string> = {
    INT6_NOT_AVAILABLE:
        'El comparativo necesita las ventas de LUGA, que llegan por la integración con La Central. Esa integración todavía no existe, así que el dato no se puede calcular.',
};

/** Por qué el silo no pudo calcular una vista del lente. Sin motivo, se dice que no lo dijo. */
export function unavailableReasonText(reason: InventoryLensUnavailableReason | null): string {
    return reason
        ? UNAVAILABLE_TEXT[reason]
        : 'El silo marcó esta vista como no calculable y no dijo por qué.';
}

/** Por qué los marcadores «Top SK» y «Top LUGA» del mockup no se pueden pintar. */
export const TOP_MARKERS_HINT =
    'Los marcadores «Top SK» y «Top LUGA» necesitan las ventas de LUGA, que llegan por la integración con La Central y todavía no existe.';

/** Stock crítico: primero el más escaso y, a igual escasez, el que más se vendió hoy. */
export function sortCritical(items: InventoryLensSkuItem[]): InventoryLensSkuItem[] {
    return [...items].sort((a, b) => a.stock - b.stock || b.soldTodayUnits - a.soldTodayUnits);
}
